import GuestLayout from '@/layouts/GuestLayout.vue';
import LoginPage from '@/pages/Auth/LoginPage.vue';
import ForgotPassword from '@/pages/Auth/ForgotPassword.vue';
import LoadingPage from '@/pages/LoadingPage.vue';
import RegisterPage from '@/pages/Auth/RegisterPage.vue';
import VerifyEmail from '@/pages/Auth/VerifyEmail.vue';
import { useAuthStore } from '@/stores/authStore';
import type { RouteLocationNormalized } from 'vue-router';
import ResetPassword from '@/pages/Auth/ResetPassword.vue';

const routes = [
  {
    path: '/account',
    component: GuestLayout,
    meta: {
      requiresAuth: false
    },
    beforeEnter: async (to: RouteLocationNormalized) => {
      const { isAuthenticated } = useAuthStore();
      if (to.name !== 'logout' && isAuthenticated) {
        return { name: 'home' };
      }
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: LoginPage
      },
      {
        path: 'forgot-password',
        name: 'password.request',
        component: ForgotPassword
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: ResetPassword
      },
      {
        path: 'register',
        name: 'register',
        component: RegisterPage
      },
      {
        path: 'verify-email/:id?/:hash?',
        name: 'verify-email',
        component: VerifyEmail,
        props: true
      },
      {
        path: 'logout',
        name: 'logout',
        beforeEnter: async () => {
          const { logout } = useAuthStore();
          await logout();
        },
        component: LoadingPage
      }
    ]
  }
];

export default routes;
